"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChevronDown = function ChevronDown(props) {
  return _react2.default.createElement(
    "svg",
    (0, _extends3.default)({ width: 18, height: 18, viewBox: "0 0 18 18" }, props),
    _react2.default.createElement("path", { d: "M11.563 7h2.617l-5.09 4.626L4 7h2.617L9.09 9.248z" })
  );
};

exports.default = ChevronDown;


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/icons/ChevronDown.js
// module id = 686
// module chunks = 0